import { App } from "../models";

export const getActiveApps = (apps: App[]) => {
  return apps.filter((app) => app.active);
};

export const getBillableApps = (apps: App[]) => {
  return apps.filter((app) => app.active && !app.is_sample);
};
